import { registerSheet } from 'react-native-actions-sheet';

import BookReservation from './BookReservation';
import DietaryOrCelebration from './DietaryOrCelebration';
import DistanceSelector from './DistanceSelector';
import Dropdown from './Dropdown';
import FullMenuList from './FullMenuList';
import MapAppOptions from './MapAppOptions';
import MealPlanList from './MealPlanList';
import MealPlanTypeSelector from './MealPlanTypeSelector';
import MultiVariant from './MultiVariant';
import OrderAgain from './OrderAgain';
import PriceSelector from './PriceSelector';
import Product from './Product';
import PromoDetails from './PromoDetails';
import Prompt from './Prompt';
import PromptWithInput from './PromptWithInput';
import PublicReview from './PublicReview';
import QRPreview from './QRPreview';
import RatingSelector from './RatingSelector';
import ViewReview from './ViewReview';

import modals, { CONTEXT } from './modals';

registerSheet(modals.BOOK_RESERVATION, BookReservation);
registerSheet(modals.DIETARY_OR_CELEBRATION, DietaryOrCelebration);
registerSheet(modals.DISTANCE_SELECTOR, DistanceSelector);
registerSheet(modals.DROPDOWN, Dropdown);
registerSheet(modals.FULL_MENU_LIST, FullMenuList);
registerSheet(modals.MAP_APP_OPTIONS, MapAppOptions);
registerSheet(modals.MEAL_PLAN_LIST, MealPlanList);
registerSheet(modals.MEAL_PLAN_TYPE_SELECTOR, MealPlanTypeSelector);
registerSheet(modals.MULTIPLE_VARIANT, MultiVariant);
registerSheet(modals.ORDER_AGAIN, OrderAgain);
registerSheet(modals.PRICE_SELECTOR, PriceSelector);
registerSheet(modals.PRODUCT, Product);
registerSheet(modals.PRODUCT, Product, CONTEXT.SEARCH_PRODUCT); // For showing the item action sheet above modal of search
registerSheet(modals.PROMO_DETAILS, PromoDetails);
registerSheet(modals.PROMPT, Prompt);
registerSheet(modals.PROMPT_WITH_INPUT, PromptWithInput);
registerSheet(modals.PUBLIC_REVIEW, PublicReview);
registerSheet(modals.QR_PREVIEW, QRPreview);
registerSheet(modals.RATING_SELECTOR, RatingSelector);
registerSheet(modals.VIEW_REVIEW, ViewReview);

export {};
